import Card from "@pathwright/ui/src/components/card/Card"
import DiscussionTagManagerCard from "@pathwright/features/src/modules/discussion/topics/DiscussionTagManagerCard"
import ManageCohortFeaturePermissions from "@pathwright/features/src/modules/feature/manage/ManageCohortFeaturePermissions"
import ManageCohortFeatures from "@pathwright/features/src/modules/feature/manage/ManageCohortFeatures"
import { featureParamToKey } from "@pathwright/features/src/modules/feature/utils"
import { getResourceSlugId } from "@pathwright/features/src/modules/utils/urls"

const getContextPropsFromParams = (params) => {
  const resourceId =
    parseInt(params.resourceId) || getResourceSlugId(params.resourceSlug)
  const cohortId = parseInt(params.cohortId)

  if (resourceId && cohortId) {
    return {
      context: {
        resource_id: resourceId,
        cohort_id: cohortId
      }
    }
  }

  // receiving component should be able to handle when only the cohort_id
  // is supplied (which will sometimes be the case)
  return { cohortId }
}

const withContext = (Component) => (props) =>
  <Component {...props} {...getContextPropsFromParams(props.match.params)} />

const ManageCohortFeaturesContainer = withContext(
  ({ card, context, cohortId }) => {
    return (
      <ManageCohortFeatures
        card={card}
        context={context}
        cohortId={cohortId}
        onChangeCommunityEnabled={(isEnabled) => {
          // updating cohort data in appropriate stores with the new discussion_enabled value
          const updates = {
            ["groupAdmin"]: "group",
            ["resource"]: "offering"
          }

          Object.entries(updates).forEach(([storeKey, attr]) => {
            try {
              App.getStore(storeKey)._mutate({
                [attr]: {
                  ...App.getStore(storeKey).getState()[attr],
                  discussion_enabled: isEnabled
                }
              })
            } catch (error) {
              console.warn(
                `Failed to update attr "${attr}" in store "${storeKey}": ${error}`
              )
            }
          })
        }}
      />
    )
  }
)

const ManageCohortFeaturePermissionsContainer = withContext(
  ({ card, match, context, cohortId }) => {
    // EDGE CASE: if user uses browser back navigation, for a moment this Component
    // will render *without* the match.params.featureKey prop, which would seem impossible
    // and may indicate a root issue in our AppRoute or related Components, suggesting
    // there is a render cycle where Component matching previous route renders with next
    // route's props.
    return match.params.featureKey ? (
      <ManageCohortFeaturePermissions
        card={card}
        featureKey={featureParamToKey(match.params.featureKey)}
        context={context}
        cohortId={cohortId}
      />
    ) : (
      <Card card={card} />
    )
  }
)

export const cohortFeaturesCardRoutes = {
  community: {
    component: ManageCohortFeaturesContainer,
    childCards: {
      // Discussion topics are not a feature governed by CFPs.
      ["discussion-topics"]: {
        component: withContext(DiscussionTagManagerCard)
      },
      ":featureKey": {
        component: ManageCohortFeaturePermissionsContainer
      }
    }
  }
}
